import dependencyInjector from './dependencyInjector';
import type { ApiInterface } from 'src/modules/api';
import { middleware as metricsMiddleware } from '@seek/metrics-js';
import createAnalyticsMiddleware from './createAnalyticsMiddleware';
import analytics from 'src/modules/analytics';
import type { Brand, Country, Language } from '@seek/melways-sites';

declare global {
  interface Window {
    CONFIG: any;
    __REDUX_DEVTOOLS_EXTENSION__: any;
  }
}

export default (
  country: Country,
  brand: Brand,
  language: Language,
  api: ApiInterface,
) => [
  dependencyInjector({ api }),
  metricsMiddleware.reduxActionMetrics({}),
  createAnalyticsMiddleware(
    analytics({
      pageAnalytics: {
        country,
        brand,
        language,
      },
    }),
  ),
];
